import React, { useEffect } from "react";
import { forArrayLength, getPluralType } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import useHandlePlayerArrays from "./useHandlePlayerArrays";

const useSearchLocally = ({ input, what, onSearched }) => {
  const { getArray } = useHandlePlayerArrays();
  const { player } = MainStore();
  function scanPlayerForObject(type) {
    const search = input.replace(/[^a-z]/gi, "").toLowerCase();
    const foundObjects = {
      active: [],
      open: [],
      saved: [],
      general: [],
    };
    const collections = ["open", "saved", "general"];
    forArrayLength(collections, (collection) => {
      const array = getArray(collection, type);
      foundObjects[collection] = array.filter(
        (o) =>
          o.id.startsWith(search) ||
          o.categories.includes(search) ||
          o.keywords.includes(search)
      );
    });
    return foundObjects;
  }

  function scanAll() {
    const foundObjects = {
      active: [],
      open: [],
      saved: [],
      general: [],
    };
    forArrayLength(player.boxTypes, (boxType) => {
      const fo = scanPlayerForObject(boxType.name);
      foundObjects.active = foundObjects.active.concat(fo.active);
      foundObjects.open = foundObjects.open.concat(fo.open);
      foundObjects.saved = foundObjects.saved.concat(fo.saved);
      foundObjects.general = foundObjects.general.concat(fo.general);
    });
    return foundObjects;
  }

  useEffect(() => {
    if (input.length > 3) {
      if (!["all"].includes(what)) onSearched(scanPlayerForObject(what));
      if (what == "all") onSearched(scanAll());
    }
  }, [input]);
};

export default useSearchLocally;
